export const BUY_LABEL_SUCCESS = 'BUY_LABEL_SUCCESS';
export const BUY_LABEL_REQUEST = 'BUY_LABEL_REQUEST';
export const BUY_LABEL_FAILURE = 'BUY_LABEL_FAILURE';
export const buyLabelSuccess = (payload) => ({
    type: BUY_LABEL_SUCCESS,
    payload,
});
export const buyLabelRequest = (payload) => ({
    type: BUY_LABEL_REQUEST,
    payload,
});
export const buyLabelFailure = (payload) => ({
    type: BUY_LABEL_FAILURE,
    payload,
});
